import i18next from "src/i18n/config";

type Labels<T extends string> = Record<T, () => string>;

// Literal `i18next.t` calls rather than a key map, so the i18n extractor can see every key.
export const rolloutStatusLabel = {
    active: () => i18next.t("common:status.active"),
    closed: () => i18next.t("common:status.closed"),
    cancelled: () => i18next.t("common:status.cancelled"),
} satisfies Labels<API.Rollout["status"]>;

export const rolloutDeviceStatusLabel = {
    pending: () => i18next.t("common:status.pending"),
    updated: () => i18next.t("common:status.updated"),
    incompatible: () => i18next.t("common:status.incompatible"),
    expired: () => i18next.t("common:status.expired"),
    cancelled: () => i18next.t("common:status.cancelled"),
} satisfies Labels<API.RolloutDeviceStatus>;

export const rolloutDeviceStatusTooltip = {
    pending: () => i18next.t("sidepanels:rolloutDetailsPanel.deviceStatusTooltip.pending"),
    updated: () => i18next.t("sidepanels:rolloutDetailsPanel.deviceStatusTooltip.updated"),
    incompatible: () => i18next.t("sidepanels:rolloutDetailsPanel.deviceStatusTooltip.incompatible"),
    expired: () => i18next.t("sidepanels:rolloutDetailsPanel.deviceStatusTooltip.expired"),
    cancelled: () => i18next.t("sidepanels:rolloutDetailsPanel.deviceStatusTooltip.cancelled"),
} satisfies Labels<API.RolloutDeviceStatus>;
